import { render, staticRenderFns } from "./ScheduledRegistrationSummaryList.vue?vue&type=template&id=2841915e&scoped=true"
import script from "./ScheduledRegistrationSummaryList.vue?vue&type=script&lang=js"
export * from "./ScheduledRegistrationSummaryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2841915e",
  null
  
)

export default component.exports